import { useState, useEffect, FC } from 'react';
import moment from 'moment';
import { Checkbox } from 'antd';

import { useSchedule } from './scheduleState/ScheduleContext';
import { Holiday, PeriodSchedule } from './ScheduleTypes';
import { ACTION_TYPES } from './scheduleState/ScheduleReducer';
import { ANALYTICS_API_BASE_URL } from '../../env';

type USHolidaysAPIProps = {
  periodId: string;
};

const USHolidaysAPI: FC<USHolidaysAPIProps> = ({ periodId }) => {
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(true);
  const [showHolidays, setShowHolidays] = useState(true);

  const { hospitalSchedule, hospitalDispatch } = useSchedule();
  const periodSchedule =
    hospitalSchedule.find((period) => period.id === periodId) ?? ({} as PeriodSchedule);

  const getHolidayAPIUrl = () => {
    // return `https://date.nager.at/api/v3/PublicHolidays/${year}/US`;
    // return `https://holidayapi.com/v1/holidays?key=d14e9d53-2503-408d-b852-bc4770886d05&country=US&year=${year}`;
    const holidayProxyAPIUrl = ANALYTICS_API_BASE_URL + '/api/v1/proxy/holidays';

    return holidayProxyAPIUrl;
  };

  useEffect(() => {
    setLoading(true);
    fetch(getHolidayAPIUrl())
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.data.holidays.filter((holiday: Holiday) => holiday.public === true) || []);
        setLoading(false);
      })
      .catch((error) => {
        // console.error('Error fetching holidays:', error);
        setLoading(false);
      });
  }, [year]);

  if (loading) return <div>Loading holidays...</div>;

  return (
    <div>
      <h2 className="border-stone-200 mb-3 flex w-fit cursor-pointer ml-2 font-bold">
        Public Holidays {year}
        <span className="font-thin ml-2 text-gray-600">(Unselect active ORs)</span>
      </h2>

      <div className="max-h-[350px] overflow-y-auto overflow-x-hidden w-fit min-w-[500px]">
        {holidays.map((holiday, idx) => (
          <div className="grid grid-cols-[100%]" key={idx}>
            <div className="flex justify-start">
              <Checkbox
                checked={!!periodSchedule.holidays?.find((h) => h.date == holiday.date)}
                onChange={(e) => {
                  const isChecked = e.target.checked;

                  hospitalDispatch({
                    type: isChecked
                      ? ACTION_TYPES.ADD_PERIOD_HOLIDAY
                      : ACTION_TYPES.REMOVE_PERIOD_HOLIDAY,
                    payload: {
                      periodId,
                      holiday: {
                        date: holiday.date,
                        name: holiday.name,
                      },
                    },
                  });
                }}
              >
                <div
                  key={idx}
                  className={`block p-3 transition-all duration-100 hover:bg-slate-200 border-b-1 border-gray-300 whitespace-nowrap w-[400px]`}
                >
                  <span>{holiday.name}</span>
                  <span className="text-gray-500">
                    &nbsp;- {moment(holiday.date).format('MM/DD/YYYY')} ({holiday.weekday.date.name}
                    )
                  </span>
                </div>
              </Checkbox>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default USHolidaysAPI;
